import React from 'react';
import bannerImage from '../Assest/OfferBanner.jpg'; // Replace with your image path

const ImageSection = () => {
  return (
    <div style={{
      width: '100%',
      height: 'auto',
      overflow: 'hidden'
    }}>
      <img
        src={bannerImage}
        alt="Banner"
        style={{
          width: '100%',
          height: 'auto',
          display: 'block',
          objectFit: 'cover'
        }}
      />
    </div>
  );
};

export default ImageSection;
